module.exports = __webpack_public_path__ + "media/images/siq_shield-31b059150d1bdb59cf2f62d8e647a6b1.png";